import { namespace, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';

namespace('Ofcs.Editor.Item');

/**
 * @class TextItem
 * @extends AbstractItem
 */
export default window.Ofcs.Editor.Item.TextItem = AbstractItem.extend({

    type: 'text',

    /**
     * Triggered when the segments are updated
     *
     * @event updatesegments
     * @param {TextItem} item Me
     */

    defaults: {
        /**
         * Instance type
         *
         * @property {string} Type
         */
        type: 'Text',

        /**
         * Current position
         *
         * @property {Point} attributes.position
         */
        position: new Point(0, 0),

        /**
         * Width of the text. Must be set by the view element,
         * after rendering
         *
         * @property {number} attributes.width
         */
        width: 0,

        /**
         * Height of the text. This will be used to calculate the font size.
         *
         * @property {number} attributes.height
         */
        height: 6,

        /**
         * Current rotation
         *
         * @property {number} attributes.rotation
         */
        rotation: 0,

        /**
         * Containing Text
         *
         * @property {string} attributes.text
         */
        text: '',

        /**
         * Used font type
         *
         * @property {string} attributes.font
         */
        // fontFamily: 'Fira Sans',
        fontFamily: 'Arial',

        /**
         * Used font size
         *
         * @property {number}
         */
        fontSize: 6,
    },

    initialize() {
        AbstractItem.prototype.initialize.call(this);

        this.supportsPositioning = true;
        this.supportsRotation = true;
        this.supportsCollisions = true;
        this.supportsOutOfFoam = true;
        this.supportsGuides = true;

        // Initialize paths
        this.set('ext', this.calculateSegments(0));
        this.set('orig', this.get('ext'));
        this.set('safety', this.calculateSegments(this.getSafetyMargin()));

        this.on('change', this.onItemChange, this);
    },

    /**
     * Return safety margin for text items
     *
     * @return {number}
     */
    getSafetyMargin() {
        return this.getParentItem().getSafetyMarginByDepth(1);
    },

    onItemChange(item) {
        const changes = item.changed;

        if (changes.width !== undefined || changes.height !== undefined) {
            this.set('ext', this.calculateSegments(0));
            this.set('orig', this.get('ext'));
            this.set('safety', this.calculateSegments(this.getSafetyMargin()));
            this.trigger('updatesegments', this);
        }
    },

    calculateSegments(spread) {
        const width = this.get('width') + (spread * 2);
        const height = this.get('height') + (spread * 2);
        const path = [];

        path.push(['M', -width / 2, -height / 2]);
        path.push(['L', width / 2, -height / 2]);
        path.push(['L', width / 2, height / 2]);
        path.push(['L', -width / 2, height / 2]);
        path.push(['L', -width / 2, -height / 2]);

        return [path];
    },
});
